import type { SxProps } from '../../themes/themes';

export const getStyles = (): { [key: string]: SxProps } => {
  return {
    text: {
      flexGrow: 0,
    },
    dense: {
      '&': { paddingLeft: 0 },
      '& .MuiListItemText-primary': { margin: 0, marginBottom: 0 },
    },
  };
};
